import { css } from '@emotion/react'
import { HeadingSection } from 'bold-ui'
import { Divider } from 'components/divider/Divider'
import { RastreioCancerPerguntaDbEnum } from 'graphql/types.generated'

import { DadosResponsavelConselhoSection } from '../DadosResponsavelConselhoSection'
import { CitopatologicoSection } from './CitopatologicoSection'
import {
  CITOPATOLOGICO_PERGUNTAS_ANAMNESE,
  CITOPATOLOGICO_PERGUNTAS_EXAME_CLINICO,
  CitopatologicoPerguntaField,
} from './model-citopatologico'

export interface CitopatologicoVisualizacaoProps {
  questoesRespondidas: Map<RastreioCancerPerguntaDbEnum, string>
}

export function CitopatologicoVisualizacao(props: Readonly<CitopatologicoVisualizacaoProps>) {
  const { questoesRespondidas } = props
  const { divider } = createStyles()

  return (
    <>
      <Divider style={divider} />
      <HeadingSection level={3} vSpace={10} title='Requisição de exame citopatológico de colo do útero' />
      <CitopatologicoSection
        questoesRespondidas={questoesRespondidas}
        questionario={CITOPATOLOGICO_PERGUNTAS_ANAMNESE}
        title='ANAMNESE'
      />
      <CitopatologicoSection
        questoesRespondidas={questoesRespondidas}
        questionario={CITOPATOLOGICO_PERGUNTAS_EXAME_CLINICO}
        title='EXAME CLÍNICO'
      />
      <DadosResponsavelConselhoSection
        titulo='DADOS DA COLETA'
        dataLabel='Data da coleta'
        data={questoesRespondidas.get(CitopatologicoPerguntaField.dataDaColeta)!}
        responsavelTitulo='Responsável pela coleta'
        nome={questoesRespondidas.get(CitopatologicoPerguntaField.nomeResponsavel)!}
        cns={questoesRespondidas.get(CitopatologicoPerguntaField.cns)!}
        conselho={questoesRespondidas.get(CitopatologicoPerguntaField.siglaNomeConselho)!}
        numero={questoesRespondidas.get(CitopatologicoPerguntaField.numeroConselho)!}
      />
    </>
  )
}

const createStyles = () => ({
  divider: css`
    width: 100%;
  `,
})
